import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36aca5d6")

_pushScopeId("data-v-36aca5d6")
const _hoisted_1 = {
  key: 0,
  class: "listState"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Loading...", -1)
const _hoisted_4 = {
  key: 1,
  class: "listState"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Aucune archive disponible", -1)
const _hoisted_7 = { class: "list--item" }
const _hoisted_8 = { class: "container--footer" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-add" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Archiver la saison ")
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "icon-attention" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_List = _resolveComponent("List")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.archiveLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3
        ]))
      : (_ctx.archiveReady && !_ctx.archive.length)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
    _createVNode("div", {
      class: ["archive--container", {'disabled': !_ctx.listReady}]
    }, [
      _createVNode(_component_List, {
        listSize: _ctx.archive.length,
        selectedItem: []
      }, {
        default: _withId(({index}) => [
          _createVNode("div", _hoisted_7, [
            _createVNode("span", null, _toDisplayString(_ctx.archive[index].name), 1)
          ])
        ]),
        _: 1
      }, 8, ["listSize"]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", {
          id: "archiveSaveBtn",
          class: ["button button--action", {'button--disabled': !_ctx.hasMatch}],
          title: _ctx.archiveButtonTitle,
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createArchive && _ctx.createArchive(...args)), ["stop"]))
        }, [
          _hoisted_9,
          _hoisted_10
        ], 10, ["title"]),
        _createVNode("div", {
          class: "notes notes--error",
          style: {
                    'visibility': _ctx.archiveError? 'visible': 'hidden'
                }
        }, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.archiveErrorMsg), 1)
        ], 4)
      ])
    ], 2)
  ]))
})